import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { theme } from "@xometry/xometry_loft";

export const FormModalCss = css`
  color: ${theme.colors.grays[0]};
  background-color: ${theme.colors.white};
  border-radius: ${theme.space[1]};
  border: none;
  box-shadow: 0 1px 4px 0 rgba(9, 44, 71, 0.15);
  padding: 0;
  width: 1300px;
  height: 88vh;
`;

export const SuccessStepContainer = styled.div`
  display: flex;
  flex-direction: column;/preview-bant/
  justify-content: center;
  align-items: center;
  height: 100%;
  h5 {
    font-size: 16px;
    margin: 0;
    margin-top: 24px;
  }
  p {
    font-size: 13px;
    margin: 4px 0 24px 0;
    color: ${theme.colors.darkBlues[75]};
    text-align: center;
  }
`;

export const AnonymousUserFormWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
`;

export const FullWidthRow = styled.div`
  width: 100%;
`;
export const DragZone = styled.div`
  align-items: center;
  background-color: #f5f9ff;
  border: 1px dashed #95bdf9;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-size: 20px;
  font-weight: 600;
  justify-content: center;
  margin: 0px;
  margin-bottom: 24px;
  padding: 30px;
  width: 100%;
  cursor: pointer;

  i.fa-cloud-upload {
    color: #0e6aed;
    display: block;
  }

  div {
    margin: 16px auto;

    > span {
      color: #0e6aed;
    }
  }

  ul {
    margin-top: 4px;
  }
`;

export const FileUploadContainer = styled.div`
  width: 100%;
  height: 100%;
  padding-top: 30px;
  box-sizing: border-box;
  h2 {
    text-align: left;
    font-size: 20px;
    width: 100%;
    font-weight: 600;
    margin: 0;
    margin-bottom: 18px;
  }
  p {
    text-align: left;
    font-size: 16px;
    width: 100%;
    color: ${theme.colors.darkBlues[75]};
    line-height: 22px;
    margin: 0;
    margin-bottom: 26px;
  }
  button {
    padding: 8px 12px;
  }
`;

export const FileListItem = styled.div`
  display: flex;
  font-size: 20px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  border-bottom: 1px solid ${theme.colors.grays[3]};
  color: #0e6aed;

  > div {
    &:last-of-type {
      color: ${theme.colors.darkBlues[75]};
      text-align: right;
      margin-left: auto;
      margin-right: 0;
    }
  }

  button {
    color: ${theme.colors.darkBlues[75]};
    padding: 0 12px;
    display: inline-block;
    font-size: 20px;
  }
`;
